import { render, staticRenderFns } from "./LeaseRents.vue?vue&type=template&id=c5d7335a&scoped=true"
import script from "./LeaseRents.vue?vue&type=script&lang=js"
export * from "./LeaseRents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d7335a",
  null
  
)

export default component.exports